export enum UrgencyLevel {
	later = 'LATER',
	soon = 'SOON',
	asap = 'ASAP, please',
}
